import React, {useEffect, useState} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {INTERACTION_COLOR_HIGHCHART, SYMBOLS_HIGHCHART} from "../utils/colorMap.js"
import {getDetailFromChartClick} from "../utils/getdetails";

export default function ScatterPlotClustered({mainData, firstRowDivHeight, results, onNestedRowClick, pdb, folder, sortOnClick}) {

    //,Res. Name 1,Res. Number 1,Chain 1,Res. Name 2,Res. Number 2,Chain 2,Type of Interactions
    const [options, setOptions] = useState([]);

    useEffect(() => {

        const all = mainData.map((mde) => {
            return {x: parseInt(mde[2]), y: parseInt(mde[5])}
        });

        const seriesClusteredByInteraction = mainData.reduce((acc, mde) => {
            let interactions = mde[7].split(";");
            interactions.forEach((interaction) => {
                interaction = interaction.trim();
                interaction = interaction.replace('*', '');
                if (interaction) {
                    let point = {x: parseInt(mde[2]), y: parseInt(mde[5]), row: mde};
                    if (acc[interaction]) {
                        acc[interaction].push(point)
                    } else {
                        acc[interaction] = [point];
                    }
                }
            });
            return acc;
        }, {});

        const seriesAll = [{
            name: `ALL(${all.length})`,
            data: all,
            animation: false
        }];

        Object.entries(seriesClusteredByInteraction).forEach(
            ([key, value], index) => {
                seriesAll.push(
                    {
                        name: `${key}(${value.length})`,
                        data: value,
                        marker: {
                            symbol: SYMBOLS_HIGHCHART[key],
                            fillColor: INTERACTION_COLOR_HIGHCHART[key]
                        },
                        point: {
                            events: {
                                click: async function () {
                                    const seriesName = this.series.name.replace(/\s?\(.*?\)/, '').trim();
                                    if (seriesClusteredByInteraction[seriesName] && seriesName !== 'ALL') {
                                        const elem = seriesClusteredByInteraction[seriesName].find(r => this.x == r.x && this.y == r.y)
                                        const row = elem.row;
                                        const res = await getDetailFromChartClick(folder, pdb, seriesName, row);
                                        const firstRow = res[0];
                                        sortOnClick(firstRow[2], firstRow[3], firstRow[1], firstRow[5], firstRow[6], firstRow[4]);
                                        onNestedRowClick(res[0], seriesName);
                                        document.getElementById("molstar").scrollIntoView({behavior: 'smooth'});
                                    }
                                }
                            }
                        }
                    });
            });

        const options = {
            chart: {
                type: 'scatter',
                zooming: {
                    type: 'xy'
                },
                height: firstRowDivHeight
            },
            xAxis: {
                title: {
                    text: results.mol1 ? `${results.mol1}` : `CHAIN ${mainData[0][3]}`,
                    style: {
                        fontWeight: 'bold',
                    }
                }
            },
            yAxis: {
                title: {
                    text: results.mol2 ? `${results.mol2}` : `CHAIN ${mainData[0][6]}`,
                    style: {
                        fontWeight: 'bold',
                    }
                }
            },
            tooltip: {
                formatter: function () {
                    const seriesName = this.series.name.replace(/\s?\(.*?\)/, '');
                    if (seriesClusteredByInteraction[seriesName]) {
                        const elem = seriesClusteredByInteraction[seriesName].find(r => this.x == r.x && this.y == r.y)
                        const row = elem.row;
                        return `${row[1]}${row[2]}_${row[3]} - ${row[4]}${row[5]}_${row[6]}`;
                    }
                }
            },
            title: {
                text: 'Atomic Interactions <br/> Contact Map'
            },
            subtitle: {
                text:
                    ''
            },
            series: seriesAll
        };

        setOptions(options);

    }, [mainData, firstRowDivHeight]);

    return (
        <div style={{paddingLeft: '40px', paddingRight: '40px'}}>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </div>
    )
}